<template>
    <div v-if="$store.state.localSpecs.length > 0">
        <h2 class="text-sm font-medium text-gray-700 mb-1">Local specs</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <global-specs-button
                v-for="spec in $store.state.localSpecs"
                :key="spec.id"
                :spec="spec"
                :badge="$store.getItemsUsingSpec(spec).length"
                class="hover:bg-gray-200"
                @click.stop="$modals.open('estimates-old-specs-local-sidepage', { spec })"
            ></global-specs-button>
        </div>
    </div>
</template>

<script>
import { estimateStore } from '@stores'

export default {
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return this.$store.state.estimate
        },
    },
}
</script>
